import React from "react"
import { Switch, Route, Redirect, useRouteMatch } from "react-router-dom"
import OrderLunch from "../../../mobile/Screens/OrderLunch/OrderLunch"
import { MeetingPlanningScreen } from "./Screens/MeetingPlanningScreen"
import { useSelector } from "react-redux"
import { IStoreState } from "../../../mobile/Reducers/rootReducer"
import { selectDeliveryForm } from "./Redux/MeetingPlanningSelectors"

export function MeetingPlanning() {
    const match = useRouteMatch()
    const { initialDeliveryForm, meetingPlaningDeliveries } = useSelector((state: IStoreState) =>
        selectDeliveryForm(state.meetingPlanningReducer)
    )

    return (<Switch>
        <Route exact path={`${match.path}`}>
            <Redirect to={`${match.path}/delivery`} />
        </Route>

        <Route path={`${match.path}/delivery/:deliveryId?`}>
            {!meetingPlaningDeliveries?.length && <Redirect to={`${match.url}/delivery`} />}
            <MeetingPlanningScreen initialDeliveryForm={initialDeliveryForm} meetingPlaningDeliveries={meetingPlaningDeliveries} />
        </Route>

        <Route path={`${match.path}/order/:kitchenId/booking/:deliveryId`}>
            {!meetingPlaningDeliveries?.length && <Redirect to={`${match.url}/delivery`} />}
            <OrderLunch />
        </Route>
    </Switch>
    )
}
